import { useState, useRef } from 'react';
import logoImg from '../../../assets/logo.png';

const CLIENT_STORAGE_KEY = 'LathiNyx_clients_v2';
function loadSavedClients() {
  try { return JSON.parse(localStorage.getItem(CLIENT_STORAGE_KEY)) || []; } catch { return []; }
}

const BRAND = {
  name: 'LathiNyx DevLabs', person: 'Aryan',
  email: 'lathinyxdevlabs@gmail.com',
  website: 'https://lathinyxdevlabs.com', address: 'Patna, Bihar, India',
};

const SERVICE_TYPES = ['Web Development','AI & ML Solutions','Research & Academic Writing','UI/UX Design','SEO & Digital Marketing','Mobile App Development','Data Analysis','Consulting','Other'];

const PDF_CSS =
  'body{font-family:Arial,Helvetica,sans-serif;padding:0;max-width:820px;margin:auto;color:#1a1a2e;font-size:11.5px;line-height:1.5}' +
  '.header{background:#1a2744;color:#fff;padding:22px 32px 18px;display:flex;justify-content:space-between;align-items:flex-start}' +
  '.header-left{display:flex;align-items:center;gap:14px}' +
  '.header-logo{height:100px;width:160px;object-fit:contain;border-radius:8px;background:#fff;padding:8px;border:2px solid rgba(255,255,255,0.4);display:block}' +
  '.header-brand{font-size:15px;font-weight:800;color:#fff;letter-spacing:0.5px;line-height:1.2}' +
  '.header-sub{font-size:10px;color:rgba(255,255,255,0.65);margin-top:2px}' +
  '.header-right{text-align:right;font-size:10px;color:rgba(255,255,255,0.7);line-height:1.8}' +
  '.header-right b{color:#fff}' +
  '.title-band{background:#243560;padding:20px 32px 22px;color:#fff}' +
  '.title-band h1{font-size:22px;font-weight:900;letter-spacing:2px;text-transform:uppercase;margin:0 0 4px;color:#fff}' +
  '.title-band .doc-sub{font-size:11px;color:rgba(255,255,255,0.6);margin-bottom:10px}' +
  '.title-band .meta-row{display:flex;gap:32px;flex-wrap:wrap;margin-top:10px}' +
  '.title-band .meta-item{font-size:10px;color:rgba(255,255,255,0.55);text-transform:uppercase;letter-spacing:0.5px}' +
  '.title-band .meta-item b{display:block;font-size:12px;color:#fff;font-weight:700;margin-top:1px;text-transform:none;letter-spacing:0}' +
  '.body{padding:24px 32px}' +
  '.sec{margin-bottom:18px;page-break-inside:avoid}' +
  '.sec-title{font-size:11px;font-weight:800;color:#1a2744;text-transform:uppercase;letter-spacing:1.2px;border-bottom:2px solid #1a2744;padding-bottom:4px;margin-bottom:10px}' +
  'p{font-size:11.5px;line-height:1.6;margin-bottom:5px;color:#1a1a2e}' +
  'table{width:100%;border-collapse:collapse;font-size:11px;margin-top:6px;page-break-inside:avoid}' +
  'td,th{padding:7px 10px;border:1px solid #d0d7e8}' +
  'th{background:#1a2744;color:#fff;font-weight:700;font-size:10px;text-transform:uppercase;letter-spacing:0.5px}' +
  'tr:nth-child(even) td{background:#f4f6fb}' +
  '.highlight{color:#c0392b;font-weight:700}' +
  '.sig{margin-top:24px;display:grid;grid-template-columns:1fr 1fr;gap:32px;page-break-inside:avoid}' +
  '.sig-line{border-top:2px solid #1a2744;padding-top:8px}' +
  '.sig-name{font-weight:800;font-size:12px;color:#1a2744;margin-bottom:1px}' +
  '.sig-role{color:#c0392b;font-weight:700;font-size:10px;margin-bottom:1px;text-transform:uppercase;letter-spacing:0.5px}' +
  '.sig-company{color:#555;font-size:10px}' +
  '.sig-img{max-height:40px;max-width:150px;object-fit:contain;display:block;margin-bottom:6px}' +
  'footer{margin-top:20px;padding:10px 32px;background:#1a2744;display:flex;justify-content:space-between;font-size:9.5px;color:rgba(255,255,255,0.6)}' +
  'footer b{color:#fff}' +
  '@media print{body{-webkit-print-color-adjust:exact;print-color-adjust:exact}}';

function f(v, fb) { return v && String(v).trim() ? v : (fb || '___________'); }
function fm(n) { return 'Rs.' + Math.round(n).toLocaleString('en-IN'); }

function buildInvHeader(ref, date, cn, cc, ce, dueDate) {
  var logoHtml = logoImg ? '<img src="' + logoImg + '" class="header-logo" alt="Logo" />' : '';
  return '<div class="header">' +
    '<div class="header-left">' + logoHtml +
    '<div><div class="header-brand">' + BRAND.name + '™</div>' +
    '<div class="header-sub">' + BRAND.email + ' &nbsp;·&nbsp; ' + BRAND.website + '</div>' +
    '<div class="header-sub">' + BRAND.address + '</div></div></div>' +
    '<div class="header-right">Invoice: <b>' + ref + '</b><br/>Date: <b>' + date + '</b><br/>Due: <b>' + dueDate + '</b></div>' +
    '</div>' +
    '<div class="title-band"><h1>INVOICE</h1>' +
    '<div class="doc-sub">' + BRAND.name + ' &nbsp;·&nbsp; ' + BRAND.address + '</div>' +
    '<div class="meta-row">' +
    '<div class="meta-item">Bill To<b>' + cn + (cc && cc !== '___________' ? ' · ' + cc : '') + '</b></div>' +
    '<div class="meta-item">Email<b>' + ce + '</b></div>' +
    '<div class="meta-item">From<b>' + BRAND.person + ' · ' + BRAND.name + '</b></div>' +
    '</div></div>' +
    '<div class="body">';
}

function openInvoicePDF(fd, items, sig) {
  var ref = f(fd.invoiceNum, 'INV-2026-' + Math.floor(Math.random()*900+100));
  var date = new Date().toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' });
  var cn = f(fd.clientName, 'Client Name'), cc = f(fd.clientCompany, 'Company'), ce = f(fd.clientEmail, 'client@email.com');
  var dueDate = f(fd.dueDate, 'Net 15 days');
  var isub = items.reduce((s, it) => s + (parseFloat(it.rate)||0)*(parseFloat(it.qty)||1), 0);
  var idisc = isub*(parseFloat(fd.discount)||0)/100, igrand = isub-idisc;
  var rows = items.filter(it => it.desc && parseFloat(it.rate)).map((it, i) => {
    var amt = (parseFloat(it.rate)||0)*(parseFloat(it.qty)||1);
    return '<tr><td>' + (i+1) + '</td><td>' + f(it.desc) + '</td><td style="text-align:center">' + (it.qty||1) + '</td><td style="text-align:right">' + fm(parseFloat(it.rate)||0) + '</td><td style="text-align:right"><b>' + fm(amt) + '</b></td></tr>';
  }).join('');
  var sigHtml = sig ? '<img src="'+sig+'" class="sig-img" alt="Signature" />' : '<div style="height:40px"></div>';
  var body = buildInvHeader(ref, date, cn, cc, ce, dueDate) +
    '<div class="sec"><div class="sec-title">Line Items</div>' +
    '<table><tr><th>#</th><th>Description</th><th style="text-align:center">Qty</th><th style="text-align:right">Unit Rate</th><th style="text-align:right">Amount</th></tr>' +
    rows + '</table></div>' +
    '<div style="margin-left:auto;width:300px;font-size:11.5px;margin-top:12px;border:1px solid #d0d7e8;border-radius:4px;overflow:hidden">' +
    '<div style="display:flex;justify-content:space-between;padding:8px 14px;border-bottom:1px solid #d0d7e8;background:#f4f6fb"><span style="color:#555">Subtotal</span><span>' + fm(isub) + '</span></div>' +
    '<div style="display:flex;justify-content:space-between;padding:8px 14px;border-bottom:1px solid #d0d7e8;background:#f4f6fb"><span style="color:#c0392b">Discount (' + (fd.discount||0) + '%)</span><span style="color:#c0392b">− ' + fm(idisc) + '</span></div>' +
    '<div style="display:flex;justify-content:space-between;padding:10px 14px;font-weight:900;font-size:14px;background:#1a2744;color:#fff"><span>Grand Total</span><span>' + fm(igrand) + '</span></div></div>' +
    '<div class="sec" style="margin-top:20px"><div class="sec-title">Payment Instructions</div>' +
    '<p>Please transfer the amount to: <b>' + BRAND.email + '</b> (UPI / Bank Transfer). Reference your invoice number <b>' + ref + '</b> in the payment description. Terms: <b>' + f(fd.paymentTerms,'Net 15 days') + '</b>.</p></div>' +
    '<div style="margin-top:24px;padding-top:14px;border-top:2px solid #1a2744">' +
    '<div style="font-size:9px;color:#888;margin-bottom:6px;text-transform:uppercase;letter-spacing:0.8px">Authorised Signatory</div>' +
    sigHtml +
    '<div class="sig-name">' + BRAND.person + '</div>' +
    '<div class="sig-role">Founder</div>' +
    '<div class="sig-company">' + BRAND.name + '™</div>' +
    '</div></div>';
  var footer = '<footer><span><b>' + BRAND.name + '™</b> &nbsp;·&nbsp; ' + BRAND.website + ' &nbsp;·&nbsp; ' + BRAND.email + '</span><span>Invoice: <b>' + ref + '</b></span></footer>';
  var html = '<!DOCTYPE html><html><head><title>Invoice ' + ref + '</title><style>' + PDF_CSS + '</style></head><body>' + body + footer + '<script>window.onload=function(){window.print();}<\/script></body></html>';
  var w = window.open('', '_blank'); w.document.write(html); w.document.close();
}

const defaultForm = {
  clientName:'', clientCompany:'', clientEmail:'',
  serviceType:'Web Development',
  invoiceNum:'INV-2026-041', dueDate:'', paymentTerms:'Net 15 days',
  discount:'10',
};

const defaultItems = [
  { id: 1, desc: 'Web Design & Development', qty: '1', rate: '40000' },
  { id: 2, desc: 'SEO & Mobile Optimization', qty: '1', rate: '8000' },
];

const INVOICE_HISTORY = [
  { num:'INV-040', client:'Aryan Consultants', amt:'₹45,000', status:'Paid', stClass:'s-paid' },
  { num:'INV-035', client:'DataMinds AI Lab', amt:'₹1,20,000', status:'Pending', stClass:'s-pending' },
  { num:'INV-028', client:'Priya Sharma', amt:'₹18,500', status:'Paid', stClass:'s-paid' },
  { num:'INV-021', client:'BuildRight Infra', amt:'₹62,000', status:'Overdue', stClass:'s-overdue' },
  { num:'INV-014', client:'ResearchHub', amt:'₹31,000', status:'Pending', stClass:'s-pending' },
];

export default function Invoices() {
  const [formData, setFormData] = useState({ ...defaultForm });
  const [items, setItems] = useState(defaultItems);
  const [showModal, setShowModal] = useState(false);
  const [clientSearch, setClientSearch] = useState('');
  const [showClientList, setShowClientList] = useState(false);
  const [signature, setSignature] = useState(null);
  const signRef = useRef(null);
  const savedClients = loadSavedClients();

  const setField = (id, val) => setFormData(prev => ({ ...prev, [id]: val }));
  const setItem = (id, key, val) => setItems(prev => prev.map(it => it.id === id ? { ...it, [key]: val } : it));
  const addItem = () => setItems(prev => [...prev, { id: Date.now(), desc: '', qty: '1', rate: '' }]);
  const removeItem = (id) => setItems(prev => prev.filter(it => it.id !== id));

  const sub = items.reduce((s, it) => s + (parseFloat(it.rate)||0)*(parseFloat(it.qty)||1), 0);
  const disc = sub*(parseFloat(formData.discount)||0)/100;
  const grand = sub - disc;
  const fmt = n => 'Rs.' + Math.round(n).toLocaleString('en-IN');

  const filteredClients = savedClients.filter(c =>
    clientSearch.length > 0 && (
      c.name.toLowerCase().includes(clientSearch.toLowerCase()) ||
      (c.company||'').toLowerCase().includes(clientSearch.toLowerCase())
    )
  );

  const selectClient = (c) => {
    setFormData(prev => ({ ...prev, clientName: c.name||'', clientCompany: c.company||'', clientEmail: c.email||'' }));
    setClientSearch(c.name); setShowClientList(false);
  };

  return (
    <div>
      <div style={{ marginBottom: 20 }}>
        <div style={{ fontSize: 17, fontWeight: 800, color: '#1a1a1a' }}>🧾 Invoices</div>
        <div style={{ fontSize: 13, color: '#555', marginTop: 4 }}>Create professional invoices with LathiNyx DevLabs letterhead</div>
      </div>

      {/* Signature card */}
      <div className="d-card" style={{ marginBottom: 16 }}>
        <div className="d-ctitle">✍️ Your Digital Signature <span className="d-badge">Appears on PDF</span></div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 20, flexWrap: 'wrap' }}>
          <div className="d-sign-upload" style={{ minWidth: 200, flex: 1 }} onClick={() => signRef.current.click()}>
            {signature
              ? <img src={signature} alt="Signature" className="d-sign-preview" />
              : <><div style={{ fontSize: 24 }}>✍️</div><p>Click to upload signature</p><p style={{ fontSize: 12, color: '#aaa' }}>PNG preferred</p></>}
          </div>
          <input ref={signRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={e => {
            const file = e.target.files[0]; if (!file) return;
            const reader = new FileReader(); reader.onload = ev => setSignature(ev.target.result); reader.readAsDataURL(file);
          }} />
          <div style={{ fontSize: 13, color: '#555' }}>
            Upload once — appears on all generated PDFs.
            {signature && <div style={{ marginTop: 8, display: 'flex', gap: 6 }}>
              <button className="d-btn d-btn-sm d-btn-primary" onClick={() => signRef.current.click()}>🔄 Replace</button>
              <button className="d-btn d-btn-sm d-btn-danger" onClick={() => setSignature(null)}>✕ Remove</button>
            </div>}
          </div>
        </div>
      </div>

      {/* Invoice doc card */}
      <div style={{ display: 'grid', gap: 14 }}>
        <div className="d-doc-card">
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: 16, marginBottom: 14 }}>
            <div className="d-doc-icon contract" style={{ fontSize: 24 }}>◈</div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 15, fontWeight: 700, color: '#1a1a1a', marginBottom: 4 }}>Invoice</div>
              <div style={{ fontSize: 13, color: '#555', marginBottom: 6 }}>Professional invoice with letterhead, line items, discount and payment instructions</div>
              <div style={{ fontSize: 12, color: '#777' }}><b style={{ color: '#1800ad' }}>Covers:</b> Bill To · Line Items · Subtotal · Discount · Grand Total · Payment Instructions</div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 4, alignItems: 'flex-end', flexShrink: 0 }}>
              <span className="d-doc-type-badge doc-type-pdf">📄 PDF</span>
            </div>
          </div>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', paddingTop: 12, borderTop: '1px solid #f0f0ec' }}>
            <button className="d-btn d-btn-primary d-btn-sm" onClick={() => setShowModal(true)}>✏️ Edit & Fill Details</button>
            <button className="d-btn d-btn-sm" style={{ background: '#fff0f2', color: '#d63a55', borderColor: '#ffc5ce' }} onClick={() => openInvoicePDF(defaultForm, defaultItems, signature)}>📄 Quick PDF</button>
          </div>
        </div>
      </div>

      {/* Invoice history */}
      <div className="d-card" style={{ marginTop: 20 }}>
        <div className="d-ctitle">Invoice History <span className="d-badge">Recent</span></div>
        <table className="d-table">
          <thead><tr><th>#</th><th>Client</th><th>Amount</th><th>Status</th></tr></thead>
          <tbody>
            {INVOICE_HISTORY.map(inv => (
              <tr key={inv.num}>
                <td style={{ color: '#7b8fff' }}>{inv.num}</td>
                <td>{inv.client}</td>
                <td>{inv.amt}</td>
                <td><span className={`d-st ${inv.stClass}`}>{inv.status}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="d-modal-overlay open" onClick={e => e.target === e.currentTarget && setShowModal(false)}>
          <div style={{ background: '#fff', borderRadius: 16, width: '94vw', maxWidth: 960, maxHeight: '96vh', display: 'flex', flexDirection: 'column', boxShadow: '0 24px 80px rgba(0,0,0,0.22)', overflow: 'hidden' }}>
            <div style={{ padding: '20px 28px 16px', borderBottom: '1px solid #e5e4f0', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0 }}>
              <div>
                <div style={{ fontSize: 18, fontWeight: 800, color: '#1a1a1a' }}>◈ Invoice</div>
                <div style={{ fontSize: 13, color: '#666', marginTop: 2 }}>Fill in the details below, then generate your invoice PDF</div>
              </div>
              <span className="d-close-btn" onClick={() => setShowModal(false)} style={{ fontSize: 28 }}>&times;</span>
            </div>

            <div style={{ flex: 1, overflowY: 'auto', padding: '24px 28px' }}>
              {/* Client auto-fill */}
              {savedClients.length > 0 && (
                <div style={{ marginBottom: 20, padding: '14px 16px', background: '#fff8fa', border: '1px solid #ffd6e0', borderRadius: 10 }}>
                  <div style={{ fontSize: 12, fontWeight: 700, color: '#ff7c90', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.6px' }}>👤 Auto-fill from Saved Clients</div>
                  <div style={{ position: 'relative' }}>
                    <input className="d-finput" placeholder="Search client name or company..." value={clientSearch}
                      onChange={e => { setClientSearch(e.target.value); setShowClientList(true); }}
                      onFocus={() => setShowClientList(true)} style={{ width: '100%' }} />
                    {showClientList && filteredClients.length > 0 && (
                      <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: '#fff', border: '1px solid #ffd6e0', borderRadius: 8, boxShadow: '0 8px 24px rgba(0,0,0,0.12)', zIndex: 100, maxHeight: 200, overflowY: 'auto' }}>
                        {filteredClients.map(c => (
                          <div key={c.id} onClick={() => selectClient(c)}
                            style={{ padding: '10px 14px', cursor: 'pointer', borderBottom: '1px solid #fff0f4', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                            onMouseEnter={e => e.currentTarget.style.background='#fff0f4'}
                            onMouseLeave={e => e.currentTarget.style.background='#fff'}>
                            <div>
                              <div style={{ fontWeight: 700, fontSize: 13, color: '#1a1a1a' }}>{c.name}</div>
                              {c.company && <div style={{ fontSize: 11, color: '#888' }}>{c.company}</div>}
                            </div>
                            <div style={{ fontSize: 11, color: '#ff7c90', fontWeight: 600 }}>Select →</div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  {formData.clientName && <div style={{ marginTop: 8, fontSize: 12, color: '#4ecba0', fontWeight: 600 }}>✓ Filled: {formData.clientName}{formData.clientCompany ? ` · ${formData.clientCompany}` : ''}</div>}
                </div>
              )}

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 28px' }}>
                {/* Bill To */}
                <div style={{ gridColumn: '1/-1', fontSize: 12, fontWeight: 700, color: '#ff7c90', textTransform: 'uppercase', letterSpacing: '0.8px', margin: '0 0 12px', paddingBottom: 6, borderBottom: '2px solid #fff0f4' }}>Bill To</div>
                {[
                  { id:'clientName', label:'Client Name', placeholder:'e.g. Rahul Sharma' },
                  { id:'clientCompany', label:'Company / Organization', placeholder:'e.g. TechCorp Pvt Ltd' },
                  { id:'clientEmail', label:'Client Email', placeholder:'client@company.com', type:'email' },
                ].map(fi => (
                  <div key={fi.id} className="d-fg">
                    <div className="d-flabel">{fi.label}</div>
                    <input className="d-finput" type={fi.type||'text'} placeholder={fi.placeholder} value={formData[fi.id]||''} onChange={e => setField(fi.id, e.target.value)} />
                  </div>
                ))}

                {/* Invoice Details */}
                <div style={{ gridColumn: '1/-1', fontSize: 12, fontWeight: 700, color: '#ff7c90', textTransform: 'uppercase', letterSpacing: '0.8px', margin: '20px 0 12px', paddingBottom: 6, borderBottom: '2px solid #fff0f4' }}>Invoice Details</div>
                <div className="d-fg">
                  <div className="d-flabel">Service Type</div>
                  <select className="d-finput" value={formData.serviceType} onChange={e => setField('serviceType', e.target.value)}>
                    {SERVICE_TYPES.map(s => <option key={s}>{s}</option>)}
                  </select>
                </div>
                <div className="d-fg">
                  <div className="d-flabel">Invoice Number</div>
                  <input className="d-finput" value={formData.invoiceNum} onChange={e => setField('invoiceNum', e.target.value)} />
                </div>
                <div className="d-fg">
                  <div className="d-flabel">Due Date</div>
                  <input className="d-finput" type="date" value={formData.dueDate} onChange={e => setField('dueDate', e.target.value)} />
                </div>
                <div className="d-fg">
                  <div className="d-flabel">Payment Terms</div>
                  <input className="d-finput" placeholder="Net 15 days" value={formData.paymentTerms} onChange={e => setField('paymentTerms', e.target.value)} />
                </div>

                {/* Line Items — dynamic */}
                <div style={{ gridColumn: '1/-1', fontSize: 12, fontWeight: 700, color: '#ff7c90', textTransform: 'uppercase', letterSpacing: '0.8px', margin: '20px 0 12px', paddingBottom: 6, borderBottom: '2px solid #fff0f4', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span>Line Items</span>
                  <button className="d-btn d-btn-sm d-btn-primary" onClick={addItem} style={{ fontSize: 12, padding: '4px 12px' }}>+ Add Item</button>
                </div>

                {items.map((it, idx) => (
                  <div key={it.id} style={{ gridColumn: '1/-1', display: 'grid', gridTemplateColumns: '1fr 80px 130px 36px', gap: 8, marginBottom: 8, alignItems: 'end' }}>
                    <div className="d-fg" style={{ margin: 0 }}>
                      <div className="d-flabel">Item {idx + 1} Description</div>
                      <input className="d-finput" placeholder="e.g. Web Design & Development" value={it.desc} onChange={e => setItem(it.id, 'desc', e.target.value)} />
                    </div>
                    <div className="d-fg" style={{ margin: 0 }}>
                      <div className="d-flabel">Qty</div>
                      <input className="d-finput" type="number" min="1" value={it.qty} onChange={e => setItem(it.id, 'qty', e.target.value)} />
                    </div>
                    <div className="d-fg" style={{ margin: 0 }}>
                      <div className="d-flabel">Rate (Rs.)</div>
                      <input className="d-finput" type="number" placeholder="0" value={it.rate} onChange={e => setItem(it.id, 'rate', e.target.value)} />
                    </div>
                    <button onClick={() => removeItem(it.id)} title="Remove item"
                      style={{ height: 36, width: 36, border: '1px solid #ffc5ce', borderRadius: 6, background: '#fff0f2', color: '#d63a55', cursor: 'pointer', fontSize: 16, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                      ✕
                    </button>
                  </div>
                ))}

                <div className="d-fg" style={{ gridColumn: '1/-1', maxWidth: 200 }}>
                  <div className="d-flabel">Discount (%)</div>
                  <input className="d-finput" type="number" min="0" max="100" value={formData.discount} onChange={e => setField('discount', e.target.value)} />
                </div>
              </div>

              {/* Live total */}
              <div style={{ background: '#fff8fa', padding: '16px 20px', borderRadius: 10, border: '1px solid #ffd6e0', marginTop: 20 }}>
                <div style={{ fontSize: 14, fontWeight: 700, color: '#1a1a1a', marginBottom: 10 }}>Invoice Total</div>
                <div style={{ display: 'flex', gap: 32, flexWrap: 'wrap', fontSize: 14 }}>
                  <div><span style={{ color: '#555' }}>Subtotal: </span><b>{fmt(sub)}</b></div>
                  <div><span style={{ color: '#d63a55' }}>Discount ({formData.discount||0}%): </span><b style={{ color: '#d63a55' }}>-{fmt(disc)}</b></div>
                  <div><span style={{ fontWeight: 700 }}>Grand Total: </span><b style={{ color: '#ff7c90', fontSize: 16 }}>{fmt(grand)}</b></div>
                </div>
              </div>

              {/* Quick preview */}
              <div style={{ marginTop: 24, background: '#f8f8ff', border: '1px solid #e5e4f0', borderRadius: 10, padding: '16px 20px' }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: '#1800ad', marginBottom: 12 }}>📋 Quick Preview</div>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 8, fontSize: 13 }}>
                  {formData.clientName && <div><span style={{ color: '#666' }}>Client: </span><b>{formData.clientName}</b></div>}
                  {formData.serviceType && <div><span style={{ color: '#666' }}>Service: </span><b>{formData.serviceType}</b></div>}
                  {formData.invoiceNum && <div><span style={{ color: '#666' }}>Invoice #: </span><b>{formData.invoiceNum}</b></div>}
                  {grand > 0 && <div><span style={{ color: '#666' }}>Total: </span><b style={{ color: '#ff7c90' }}>{fmt(grand)}</b></div>}
                  {formData.dueDate && <div><span style={{ color: '#666' }}>Due: </span><b>{formData.dueDate}</b></div>}
                  <div><span style={{ color: '#666' }}>Items: </span><b>{items.filter(it => it.desc).length}</b></div>
                </div>
                {signature && <div style={{ marginTop: 10, paddingTop: 10, borderTop: '1px solid #e5e4f0', display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span style={{ fontSize: 12, color: '#666' }}>Signature:</span>
                  <img src={signature} alt="sig" style={{ maxHeight: 36, maxWidth: 120, objectFit: 'contain' }} />
                </div>}
              </div>
            </div>

            <div style={{ padding: '16px 28px', borderTop: '1px solid #e5e4f0', display: 'flex', gap: 10, flexWrap: 'wrap', flexShrink: 0, background: '#fafaf8' }}>
              <button className="d-btn d-btn-primary" onClick={() => openInvoicePDF(formData, items, signature)}>📄 Generate PDF</button>
              <button className="d-btn" style={{ marginLeft: 'auto' }} onClick={() => setShowModal(false)}>✕ Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
